import React from "react";
import { Link } from "react-router-dom";
import { Quotes, MapPin, Calendar } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const STORIES = [
  {
    id: "fatima-ahmed",
    couple: "Fatima & Ahmed",
    location: "Hyderabad → Toronto",
    date: "Nikah, Autumn 2025",
    quote: "The matchmaker understood our family in a way even our closest relatives could not. She listened first, and matched later. Alhamdulillah, our journey was quiet, respectful, and unhurried.",
    body: "Fatima's mother had been searching for two years across three platforms. In her first week on WR Rishtey, she received a shortlist of six — every one hand-picked with family, sect, and geography in mind. Ahmed's introduction was fourth on the list.",
  },
  {
    id: "aisha-zayd",
    couple: "Aisha & Zayd",
    location: "Karachi → London",
    date: "Nikah, Spring 2025",
    quote: "We spoke for weeks through the platform before ever exchanging phone numbers. Our families met on video call before our first in-person meeting. Every step felt safeguarded.",
    body: "Aisha and Zayd shared a common wali who reviewed both families before their introduction. Their Nikah was conducted with the same relationship manager they were paired with, in-shaa-Allah.",
  },
  {
    id: "maryam-hamza",
    couple: "Maryam & Hamza",
    location: "Bengaluru → Riyadh",
    date: "Nikah, Winter 2024",
    quote: "We were both divorced (post-iddat) and looking for a second chance with reverence. The platform did not treat us as a lesser category — we were curated the same way, with dignity.",
    body: "Maryam had been widowed young; Hamza had one child from a previous marriage. Their matchmaker specialised in second-marriage introductions and shared their profiles only with families who understood.",
  },
  {
    id: "zainab-ibrahim",
    couple: "Zainab & Ibrahim",
    location: "Kuala Lumpur → Sydney",
    date: "Nikah, Summer 2025",
    quote: "As a hafiza, I wanted a husband who valued the Quran the way I did. The platform's Deen tab made this a searchable priority — not something to bury in small talk.",
    body: "Ibrahim was an aspiring alim; Zainab a hafiza and paediatrician. Their alignment was flagged by the system, then confirmed by a human matchmaker before the introduction went out.",
  },
];

export default function Stories() {
  return (
    <div className="max-w-[1100px] mx-auto px-6 md:px-10 py-16" data-testid="stories-page">
      <div className="text-center">
        <div className="label-eyebrow text-brand-terracotta">Success Stories</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tighter mt-4 text-brand-ink">Nikahs solemnised,<br /><em>hearts settled.</em></h1>
        <p className="mt-6 text-brand-muted max-w-2xl mx-auto leading-relaxed">
          Every story below began with a single introduction on WR Rishtey.
          Names are used with the couple's permission. Alhamdulillah for every union.
        </p>
      </div>

      <div className="mt-16 space-y-16" data-testid="stories-list">
        {STORIES.map((s, i) => (
          <article key={s.id} className="border border-brand-line bg-white p-8 md:p-12" data-testid={`story-${s.id}`}>
            <div className="grid md:grid-cols-12 gap-8 items-start">
              <div className="md:col-span-4">
                <div className="label-eyebrow text-brand-muted">Story {String(i + 1).padStart(2, "0")}</div>
                <div className="mt-3 font-serif text-3xl md:text-4xl text-brand-ink leading-tight">{s.couple}</div>
                <div className="mt-4 text-sm text-brand-muted space-y-1.5">
                  <div className="flex items-center gap-2"><MapPin size={14} /> {s.location}</div>
                  <div className="flex items-center gap-2"><Calendar size={14} /> {s.date}</div>
                </div>
              </div>
              <div className="md:col-span-8">
                <Quotes size={26} weight="fill" className="text-brand-terracotta" />
                <p className="font-serif italic text-2xl md:text-3xl text-brand-ink leading-tight mt-3">"{s.quote}"</p>
                <p className="mt-6 text-brand-muted leading-relaxed">{s.body}</p>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-20 text-center border-t border-brand-line pt-12">
        <h2 className="font-serif text-3xl md:text-4xl text-brand-ink tracking-tight">Have a story of your own?</h2>
        <p className="mt-3 text-brand-muted">If WR Rishtey helped bring your families together, we'd be honoured to feature you.</p>
        <Button asChild className="mt-6 rounded-full bg-brand-terracotta hover:bg-brand-terracotta/90 text-white px-8 py-6" data-testid="stories-cta-contact">
          <Link to="/contact">Share your story →</Link>
        </Button>
      </div>
    </div>
  );
}
